import { object, string } from 'yup';

export const reportProductSchema = object().shape({
  description: string().required('لطفا توضیحات را وارد نمایید'),
});
